import { render } from "./clue.vue?vue&type=template&id=12976712&scoped=true"
import script from "./clue.vue?vue&type=script&lang=js"
export * from "./clue.vue?vue&type=script&lang=js"

import "./clue.vue?vue&type=style&index=0&id=12976712&scoped=true&lang=css"
import "./clue.vue?vue&type=style&index=1&id=12976712&lang=css"
script.render = render
script.__scopeId = "data-v-12976712"

export default script